<template>

    <div class="w-full">

        <div class="flex w-full items-center justify-between font-medium gap-x-2 text-sm">
            <span class="flex-grow">
                <input type="text" ref="rule_name" v-model="_rule.name" @input="validateInputTitle" class="text-left w-fit inline-block py-2 mt-0 px-0 border-0 focus:px-3 focus:ring-0 font-medium
             bg-white focus:bg-gray-100 text-gray-900 focus:text-birdie-blue active:text-birdie-blue rounded-lg text-sm
             placeholder:font-normal min-w-0 max-w-md" placeholder="Name your rule…" :style="{ width: inputWidth }" />
            </span>
            <div class="flex items-center flex-shrink-0">
                <toggle :checked="_rule.enabled" @click.prevent.stop @update="toggleRule"></toggle>
            </div>
            <div v-if="_rule.id"
                class="flex items-center justify-center size-6 flex-shrink-0 rounded-full hover:bg-gray-100 cursor-pointer"
                @click="deleteRule" v-tippy="{ content: 'Delete rule', delay: 500 }">
                <XMarkIcon class="size-4" />
            </div>
        </div>

        <div class="flex mt-5 text-sm justify-start items-center gap-x-2">

            <span class="font-mono text-gray-600 flex-shrink-0">If a video is from</span>

            <div class=" flex-shrink-0">
                <select id="" name="subject" v-model="_rule.ruleset.conditions[0].sub_conditions[0].value"
                    class="text-sm border-0 outline-none ring-0 pr-7 bg-gray-100  text-gray-900 w-26 text-left focus:ring-0 focus:ring-offset-0 focus:outline-none rounded-md font-medium"
                    @change="updateSubject">
                    <option v-for="(subject, index3) in helpdesk_values" :key="'val_' + index2 + '_' + index3"
                        :value="subject.slug">{{ subject.name }}</option>
                </select>
            </div>

            <span v-if="_rule.ruleset.conditions[0].sub_conditions[0].value == 'universal'" class="font-mono text-gray-600 flex-shrink-0">and link?tag= param is</span>
            <span v-else class="font-mono text-gray-600 flex-shrink-0">and the ticket has the tag</span>

            <div class="flex-grow">
                <input type="text" ref="name" v-model="_rule.ruleset.conditions[0].sub_conditions[1].value"
                    @input="validateInputTag" class="text-left w-full inline py-2 mt-0 px-3 border-0
                    border-gray-200 focus:ring-0 focus:border-blue-500 font-medium
                    bg-gray-100 text-gray-900 focus:text-birdie-blue rounded-lg text-sm placeholder:font-normal"
                    placeholder="tag-name" />
            </div>

            <span class="font-mono text-gray-600 flex-shrink-0">then route it to the folder</span>

            <Menu as="div" class="relative z-10 flex items-center justify-end flex-shrink-0" v-slot="{ close, open }">

                <div class="flex items-center justify-start">

                    <MenuButton class="rounded-lg py-2 px-3 flex justify-start items-center text-gray-600 bg-gray-100">
                        <span v-if="currentFolder && currentFolder.is_secure" class="max-w-30 inline-block truncate">
                            <LockClosedIcon class="size-3 flex-shrink-0 mr-1" />
                        </span>
                        <span
                            :class="[_rule.name == '' ? 'text-gray-600' : 'text-gray-900', 'max-w-30 inline-block truncate']">{{
                            folderName
                            }}</span>
                        <ChevronDownIcon class="size-4 ml-2" />
                    </MenuButton>

                </div>

                <transition enter-active-class="transition ease-out duration-100"
                    enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100"
                    leave-active-class="transition ease-in duration-75"
                    leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
                    <MenuItems
                        :class="[openSide == 'right' ? 'left-0 origin-bottom-left' : 'right-0 origin-bottom-right', 'absolute  bottom-full z-10 mb-2 w-60  rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none max-h-56 overflow-y-auto']">
                        <div class="py-1">
                            <MenuItem v-if="titleRoot != null" v-slot="{ active }">
                            <div class="px-4 py-2 text-sm flex items-center justify-start text-gray-600">
                                <FolderIconSolid class="size-4 mr-2" />
                                <span class="inline-block truncate font-bold">Incoming</span>
                            </div>

                            </MenuItem>
                            <MenuItem v-for="folder in foldersOrdered" v-slot="{ active }" :key="'folder_' + folder.id">

                            <div v-if="_rule.ruleset.action.value && folder.id == _rule.ruleset.action.value"
                                class="pl-10 pr-4 py-2 text-sm flex items-center justify-start gap-x-1 bg-birdie-blue text-white">
                                <FolderIconOutline class="size-4 flex-shrink-0" />
                                <span class="inline-block truncate">{{ folder.name }}</span>
                            </div>
                            <a v-else href="#" @click.prevent.stop="updateFolder(folder); close()" :class="[active ? 'bg-gray-100 text-gray-900 outline-none' : 'text-gray-700',
                            folder.is_secure ? '' : '',
                                'pl-10 pr-4 py-2 text-sm flex items-center justify-start group']">
                                <span class="block size-4 ml-0 mr-2 flex-shrink-0 relative">
                                    <!-- <span v-html="folderIcon"></span> -->
                                    <FolderIconOutline class="size-4" />
                                    <div v-if="folder.is_secure"
                                        class="absolute bottom-0 -right-0.5 size-2 rounded-full bg-white group-hover:bg-gray-100 flex items-center justify-center text-gray-900">
                                        <LockClosedIcon class="size-5/6 " />
                                    </div>
                                </span>
                                <span class="inline-block truncate">{{ folder.name }}</span>
                            </a>
                            </MenuItem>
                        </div>
                    </MenuItems>
                </transition>
            </Menu>



        </div>



    </div>

</template>

<script>

import Toggle from '@/Components/UI/Toggle'
import UpgradePlan from '@/Components/UI/UpgradePlan'
import JetSectionBorder from '@/Jetstream/SectionBorder'
import JetDropdown from '@/Jetstream/Dropdown'
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import { LockClosedIcon } from "@heroicons/vue/16/solid"
import { CheckIcon, ChevronDownIcon, XMarkIcon, FolderIcon as FolderIconSolid } from "@heroicons/vue/24/solid"
import { FolderIcon as FolderIconOutline } from "@heroicons/vue/24/outline"

export default {

    props: ['rule', 'folders'],

    components: {
        Toggle, JetSectionBorder, JetDropdown, UpgradePlan,
        Menu, MenuButton, MenuItem, MenuItems,
        LockClosedIcon, FolderIconSolid, CheckIcon, ChevronDownIcon,
        XMarkIcon, FolderIconOutline
    },

    created: function () {


    },

    data() {
        return {
            timeout: Object,
            buffer: 1000,
            lastTypeMoment: 0,
            openSide: 'left',
            _rule: this.rule,
            titleRoot: "Incoming",
            saving: false,
            subjects: [
                {
                    name: "Video Source",
                    slug: "video_source"
                },
                {
                    name: "Ticket tag",
                    slug: "ticket_tag"
                }
            ],
            operators: [
                {
                    name: "is",
                    slug: "is"
                },
                // {
                //     name: "is not",
                //     slug: "is_not"
                // },
                // {
                //     name: "contains",
                //     slug: "contains"
                // },
                // {
                //     name: "does not contain",
                //     slug: "does_not_contain"
                // },
                // {
                //     name: "starts with",
                //     slug: "starts_with"
                // },
                // {
                //     name: "ends with",
                //     slug: "ends_with"
                // }
            ],

            helpdesk_values: [
                {
                    name: "Zendesk",
                    slug: "zendesk"
                },
                {
                    name: "Intercom",
                    slug: "intercom"
                },
                {
                    name: "Recording Link",
                    slug: "universal"
                }
            ],
            subjects_actions: [
                {
                    name: "Video",
                    slug: "video"
                },
                // {
                //     name: "User",
                //     slug: "user"
                // },
                // {
                //     name: "Ticket",
                //     slug: "ticket"
                // }
            ],
            actions_actions: [
                {
                    name: "Move to folder",
                    slug: "move_folder"
                },
                // {
                //     name: "Add Tag",
                //     slug: "add_tag"
                // },
                // {
                //     name: "Remove Tag",
                //     slug: "remove_tag"
                // },
                // {
                //     name: "Send Email",
                //     slug: "send_email"
                // }
            ]
        }
    },

    mounted: function () {
        this._folders = this.folders
        if (this._rule.name == "") {
            this.$refs.rule_name.focus()
        }
    },

    methods: {
        validateInputTag(event) {
            // Update the model value directly
            this._rule.ruleset.conditions[0].sub_conditions[1].value =
                this._rule.ruleset.conditions[0].sub_conditions[1].value.replace(/\s+/g, '-').replace(/[^a-zA-Z0-9\-#_]/g, ''); // no space allowed spaces are replaced by dash

            let now = new Date().getTime();
            if (now - this.lastTypeMoment < this.buffer) {
                clearTimeout(this.timeout);
            }
            this.timeout = setTimeout(function () { this.updateRule() }.bind(this), this.buffer);
            this.lastTypeMoment = now;
        },
        validateInputTitle(event) {
            // remove any html tags and limit to 200 characters
            this._rule.name = this._rule.name.replace(/<[^>]*>?/g, '').substring(0, 200);

            let now = new Date().getTime();
            if (now - this.lastTypeMoment < this.buffer) {
                clearTimeout(this.timeout);
            }
            this.timeout = setTimeout(function () { this.updateRule() }.bind(this), this.buffer);
            this.lastTypeMoment = now;
        },
        updateFolder(folder) {
            this._rule.ruleset.action.value = folder.id
            console.log('updateFolder', this._rule)
            this.updateRule()
        },
        toggleRule() {
            this._rule.enabled = !this._rule.enabled
            this.updateRule()
        },
        updateSubject() {
            console.log('updateSubject', this._rule)
            this.updateRule()
        },
        updateRule() {
            console.log('updateRule', this._rule)
            if (!this._rule.id || this.saving) {
                return
            }
            this.saving = true
            let url = this.$page.props.api_url + '/v1/rule/' + this._rule.id;
            axios.post(url, {
                rule: this._rule
            })
                .then(response => {
                    this._rule = response.data
                    let options = {
                        type: "default",
                        timeout: 2500,
                        position: "top-right",
                        hideProgressBar: false,
                    }
                    this.$moshaToast("Rule saved", options)
                    this.saving = false
                })
                .catch(e => {
                    console.error(e);
                    let options = {
                        type: "danger",
                        timeout: 10000,
                        position: "top-right",
                        hideProgressBar: false,
                    }
                    this.$moshaToast("An error occurred: " + e.response.data.message, options)
                    this.saving = false
                });
        },
        deleteRule() {
            this.$emit('deleteRule', this._rule)
        }

    },

    computed: {
        // Calculate width in 'ch' units based on the length of _rule.name.
        inputWidth() {
            const minChars = 15; // Minimum number of characters
            const maxChars = 60; // Maximum number of characters
            // Use the length of the current text or minChars if empty.
            const currentLength = this._rule.name?.length || minChars;
            // Clamp the width between minChars and maxChars.
            const effectiveChars = Math.min(Math.max(currentLength, minChars), maxChars);
            // px-3 adds 0.75rem on each side = 1.5rem total. Only add this extra width when focused.
            const paddingExtra = '1.5rem';
            return `calc(${effectiveChars}ch + ${paddingExtra})`;
            // return effectiveChars + 'ch';
        },
        folderName() {
            if (this._rule.ruleset.action.value) {
                return this.folders.find(folder => folder.id == this._rule.ruleset.action.value).name
            }
            return 'Select a folder'
        },
        currentFolder() {
            return this.folders.find(folder => folder.id == this._rule.ruleset.action.value) || null
        },
        foldersOrdered() {
            return this.folders.sort((a, b) => a.name.localeCompare(b.name))
        },

    }
}


</script>
